import { authHeader } from "@/_helpers";
import axios from "axios";
import router from "../router";

export const apiService = {
  editUser,
  getAll,
  logout,
  register,
  resetPassword,
  validateCode,
  setRessetPassword,
  checkCallback
};

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem("sourcelink");
  localStorage.removeItem("userData");
  localStorage.removeItem("user");
}

async function register(user) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    username: user.username,
    password: user.password,
    password_confirmation: user.password_confirmation,
    email: user.email,
    terms_condition: JSON.stringify(user.terms_condition)
    // params: JSON.stringify(user)
  };
  return await axios
    .post(`${process.env.VUE_APP_URL}/account/`, requestOptions)
    .then(handleResponse)
    .catch(function(error) {
      handleError(error);
    });
}

function editUser(user) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    username: user.username,
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
    pk_idusers: user.pk_idusers,
    password_old: user.password_old,
    password_new: user.password_new,
    password_new_confirm: user.password_new_confirm,
    phone: user.phone,
    Country: user.Country,
    city: user.city,
    address: user.address,
    company: user.company,
    role: user.role,
    web_page: user.web_page,
    sector: user.sector,
    Ventas: user.Ventas,
    foreign_currency_exposure: user.foreign_currency_exposure,
    type_foreign_currency_exposure: user.type_foreign_currency_exposure,
    commodity_exposure: user.commodity_exposure,
    type_commodity_exposure: user.type_commodity_exposure,
    habeas_data: user.habeas_data
  };
  return axios
    .post(`${process.env.VUE_APP_URL}/user/update`, requestOptions)
    .then(handleResponse);
}

async function resetPassword(email) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    email: email
  };
  return await axios
    .post(`${process.env.VUE_APP_URL}/user/resetpassword`, requestOptions)
    .then(handleResponse)
    .catch(function(error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      return ["Failed to process password reset request, Try again."];
    });
}

async function validateCode(email, code, password) {
  const requestBody = {
    email: email,
    code: code,
    password: password
  };

  return await axios
    .post(`${process.env.VUE_APP_URL}/user/validatecode`, requestBody, {
      headers: {
        "Content-Type": "application/json"
      }
    })
    .then(handleResponse)
    .catch(function(error) {
      if (error.response) {
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        console.log(error.request);
      } else {
        console.log("Error", error.message);
      }
      return ["Failed to process password reset request, Try again."];
    });
}

function setRessetPassword(user) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    pk_idusers: user.pk_idusers,
    password: user.password,
    password_confirmation: user.password_confirmation
  };
  return axios
    .post(`${process.env.VUE_APP_URL}/user/setRessetPassword`, requestOptions)
    .then(handleResponse);
}

var getRequest = async function(endpoint, query_params) {
  return await axios
    .get(`${process.env.VUE_APP_URL}/${endpoint}/`, {
      headers: authHeader(),
      params: query_params
    })
    .catch(function(error) {
      handleError(error);
    });
};

var postRequest = async function(endpoint, query_params, content_type) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    params: query_params
  };
  requestOptions.headers["Content-Type"] = content_type;
  let requestOptionsSended = {};
  switch (content_type) {
    case "multipart/form-data":
      requestOptionsSended = requestOptions.params.formData;
      break;
    case "application/json":
      requestOptionsSended = requestOptions;
      break;
    default:
      break;
  }
  return await axios
    .post(`${process.env.VUE_APP_URL}/${endpoint}/`, requestOptionsSended, {
      headers: requestOptions.headers
    })
    .then(handleResponse)
    .catch(function(error) {
      handleError(error);
    });
};

var putRequest = function(endpoint, query_params, content_type) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    params: query_params
  };
  requestOptions.headers["Content-Type"] = content_type;
  let requestOptionsSended = {};
  switch (content_type) {
    case "multipart/form-data":
      requestOptionsSended = requestOptions.params.formData;
      break;
    case "application/json":
      requestOptionsSended = requestOptions;
      break;
    default:
      break;
  }
  return axios
    .put(`${process.env.VUE_APP_URL}/${endpoint}/`, requestOptionsSended, {
      headers: requestOptions.headers
    })
    .catch(function(error) {
      handleError(error);
    });
};

function handleRequest(params) {
  let data = null;
  switch (params.method) {
    case "GET":
      data = getRequest(params.endpoint, params.query_params)
        .then(response => {
          return response.data;
        })
        .catch(e => {
          console.error(e);
        });
      break;
    case "POST":
      data = postRequest(
        params.endpoint,
        params.query_params,
        params.content_type
      )
        .then(response => {
          if (response.status === 500) {
            // auto logout if 401 response returned from api
            return response.statusText;
          }
          // response.data.successfully
          //
          try {
            return response.data.successful;
          } catch (error) {
            return response;
          }
        })
        .catch(e => {
          console.error(e);
        });
      break;
    case "PUT":
      data = putRequest(
        params.endpoint,
        params.query_params,
        params.content_type
      )
        .then(response => {
          if (response.status === 500) {
            // auto logout if 401 response returned from api
            return response.statusText;
          }
          // response.data.successfully
          return response.data.successful;
        })
        .catch(e => {
          console.error(e);
        });
      break;
    default:
      break;
  }
  return data;
}

function getAll(params) {
  return handleRequest(params);
}

function handleError(error) {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    console.error(error.response.data);
    console.error(error.response.status);
    console.error(error.response.headers);
    if (error.response.status === 401 || error.response.status === 403) {
      // auto logout if 401 response returned from api
      logout();
      router.push("/logout");
      location.reload(true);
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.error(error.request);
  } else {
    // Something happened in setting up the request that triggered an Error
    console.error("Error", error.message);
  }
  console.error(error.config);
}

function handleResponse(response) {
  const data = response.data;
  // const data = text && JSON.parse(text);
  if (!response.statusText) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      // console.error("handleResponse(response)");
      console.error(response);
      //logout();
      //router.push("/logout");
      //location.reload(true);
    } else {
      // console.error("handleResponse(response)");
      console.error(response.status);
    }
    const error = (data && data.message) || response.statusText;
    return Promise.reject(error);
  }
  return data;
}


async function checkCallback(code, state, session_state) {
  const data = {
    code: code,
    state: state,
    session_state: session_state
  };

  const config = {
    headers: {
      "Content-Type": "application/json"
    }
  };

  console.log(data);

  return await axios
    .post(`${process.env.VUE_APP_URL}/oidc/callback/`, data, config)
    .then(handleResponse)
    .catch(handleError);
}